import * as React from "react";

import styled from "@emotion/styled";
import Inc5000Image from "../images/trusted-by/inc-5000.png";
import { breakpoints } from "../styles/breakpoints";

const StyledInc5000 = styled.img`
  display: block;
  height: 120px;
  margin-top: var(--xx-small);

  @media (max-width: ${breakpoints.md}) {
    height: 100px;
  }

  @media (max-width: ${breakpoints.xs}) {
    height: 90px;
  }
`;

export const Inc5000 = () => (
  <StyledInc5000 src={Inc5000Image} alt="Inc 5000" />
);
